import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UserContactModule } from '@osapp/modules/contacts/userContact/user-contact.module';
import { LightingUpAngularModule } from 'lighting-up-angular';
import { SidePageDesmosModule } from '../../features/connexion/components/side-page-desmos/side-page-desmos.module';
import { AuthenticatorComponent } from './authenticator.component';


/**
 * Module de gestion des formlist
 */
@NgModule({
	imports: [
		IonicModule,
		CommonModule,
		FormsModule,
		RouterModule,
		UserContactModule,
		SidePageDesmosModule,
		LightingUpAngularModule,
		MatIconModule,
		ReactiveFormsModule
	],
	exports: [AuthenticatorComponent],
	declarations: [AuthenticatorComponent],
	providers: []
})
export class AuthenticatorModule {
}
